import {
  getServerSidePropsBlockPage,
  BlockPageProps,
} from 'modules/block-page/shared';
import { useTenantConfig } from 'hooks';
import dynamic from 'next/dynamic';

const BlockPage = dynamic(() =>
  import('modules/block-page/desktop').then((mod) => mod.BlockPage),
);

const SearchPage = dynamic(() =>
  import('modules/search-page/desktop').then((mod) => mod.SearchPage),
);

const defaultGetServerSideProps = () => {
  return {
    props: {},
  };
};

export const getServerSideProps: GetServerSideProps = ((context) =>
  !context?.req?.tenantEnv?.epicPb1887
    ? getServerSidePropsBlockPage(context)
    : defaultGetServerSideProps()) as GetServerSideProps;

const SellerPage: React.FC<BlockPageProps> = (props) => {
  const { epicPb1887 } = useTenantConfig();
  return !epicPb1887 ? (
    <BlockPage {...(props as BlockPageProps)} forceNoIndex />
  ) : (
    <SearchPage forceNoIndex />
  );
};

export default SellerPage;
